module.exports = __webpack_public_path__ + "img/single-img-2_1single-img-2.ec19800a.png";